import globalConfig from '../config/global/config.json';
import i18n from '../i18n';
import { setMarketDataLayer } from './GTM';
import { createLogs } from './proactiveMonitoring';
import { find } from 'lodash';

export const validLocale = (locale, cluster) => {
    if (cluster) {
        if (globalConfig.SET_CLUSTER_LOCALE_WHITELIST.includes(locale)) {
            checkStoredLocale(locale);
            return true;
        }
        else {
            let defaultLocale = globalConfig.SET_DEFAULT_MARKET;
            i18n.changeLanguage(defaultLocale);
            checkStoredLocale(defaultLocale);
            return false;
        }
    }
    else {
        if (globalConfig.SET_LOCALE_WHITELIST.includes(locale)) {
            i18n.changeLanguage(locale.replace('-', '_'));
            checkStoredLocale(locale);
            return true;
        } else {
            let defaultLocale = globalConfig.SET_DEFAULT_MARKET;
            i18n.changeLanguage(defaultLocale);
            checkStoredLocale(defaultLocale);
            return false;
        }
    }
};

export const validCluster = (cluster) => {
    if (globalConfig.SET_LOCALE_WHITELIST.includes(cluster)) {
        i18n.changeLanguage(cluster);
        return true;
    }
    else {
        let defaultLocale = globalConfig.SET_DEFAULT_MARKET;
        checkStoredLocale(defaultLocale);
        return false;
    }
};

export const validUserId = crmId => (crmId === "" || crmId === undefined || crmId === null) ? false : true;

export const validEmailId = emailId => regex.test(emailId);

// eslint-disable-next-line
const regex = new RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}');

export const validAccountType = accountType => (accountType === "lite" || accountType === "full") ? true : false;

// function to return the first matched element or undefined if nothing matches 
export const findElement = (element, Arr) => {
    return find(Arr, function (consent) {
        return (consent.toLowerCase() === element.toLowerCase());
    });
};

export const validChannel = (channel, validConsentsArray) => {
    const channelArr = channel.split(',');
    const validChannelArray = [];
    const invalidChannelArray = [];
    channelArr.map((channel) => {
        const foundElement = findElement(channel, validConsentsArray);
        if (foundElement) {
            return validChannelArray.push(foundElement);
        }
        else {
            return invalidChannelArray.push(channel);
        }
    })
    if (validChannelArray.length >= 1) {
        // set the session storage with valid value
        sessionStorage.setItem('channel', validChannelArray.join(','));
        if (invalidChannelArray.length > 0) {
            createLogs("2", {
                data: {
                    message: `Invalid values in channel parameter - ${invalidChannelArray.join(',')}`,
                    emailId: sessionStorage.getItem('em'),
                    userId: sessionStorage.getItem('id')
                },
                errorCode: "ERR_CSP-10011",
                locale: sessionStorage.getItem('locale'),
                requestName: "invalid_channel_parameters"
            });
        }        
        return true;
    } else {
        createLogs("2", {
            data: {
                message: 'Invalid consent type in channel parameter',
                emailId: sessionStorage.getItem('em'),
                userId: sessionStorage.getItem('id')
            },
            errorCode: "ERR_CSP-10008",
            locale: sessionStorage.getItem('locale'),
            requestName: "invalid_channel_parameters"
        });
        return false;
    }
};

export const validUnsubscribe = unSubscribe => (unSubscribe === "true" || unSubscribe === "false") ? true : false;

const checkStoredLocale = locale => {
    if (sessionStorage.getItem('locale') !== locale) {
        setMarketDataLayer(locale);
        sessionStorage.setItem('locale', locale);
    }
}